import { gql } from "@apollo/client";

export const CREATE_N8N_WORKFLOW_MUTATION = gql`
  mutation CreateN8nWorkflow($input: CreateN8nWorkflowInput!) {
    createN8nWorkflow(input: $input) {
      id
      name
      nodes
      connections
      tenantId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_N8N_WORKFLOW_MUTATION = gql`
  mutation UpdateN8nWorkflow($input: UpdateN8nWorkflowInput!) {
    updateN8nWorkflow(input: $input) {
      id
      name
      nodes
      connections
      tenantId
      updatedAt
    }
  }
`;

export const DELETE_N8N_WORKFLOW_MUTATION = gql`
  mutation DeleteN8nWorkflow($input: DeleteN8nWorkflowInput!) {
    deleteN8nWorkflow(input: $input) {
      id
      success
    }
  }
`;

export const EXECUTE_N8N_WORKFLOW_MUTATION = gql`
  mutation ExecuteN8nWorkflow($input: ExecuteN8nWorkflowInput!) {
    executeN8nWorkflow(input: $input) {
      id
      status
      result
      startedAt
      completedAt
    }
  }
`;
